import numberWithCommas from './numberFormat'

type Value = string | number | undefined | null

const formatNumberWithDecimal = (
  value: Value,
  showDecimal:
    | false
    | {
        /** Number of decimal places (Number.prototype.toFixed) */
        toFixed?: number
        /** Auto omitted redundant zero in final result (Ex: 0.1200 -> 0.12 - 0.1201 -> 0.1201) */
        dynamicLength?: boolean
      } = { toFixed: 2, dynamicLength: true }
) => {
  // Type guard
  if (typeof value !== 'number' && typeof value !== 'string') return null
  if (
    // `value` is already a number ⇒ reject NaN
    (typeof value === 'number' && Number.isNaN(value)) ||
    // `value` is a string ⇒ reject empty or non-numeric strings
    (typeof value === 'string' &&
      (value.trim().length === 0 || Number.isNaN(Number(value))))
  )
    return null

  // Nếu không show decimal
  if (showDecimal === false || !value.toString().includes('.'))
    return numberWithCommas(Math.round(Number(value)).toString())

  // Convert decimal
  const [integer, decimal = ''] = value.toString().split('.')

  const toFixLength = showDecimal?.toFixed ?? 2

  // Format decimal theo tùy chỉnh toFixed
  const toFixedDecimal =
    decimal && !Number.isNaN(Number(decimal))
      ? decimal.padEnd(toFixLength, '0').substring(0, toFixLength)
      : ''

  // Format decimal theo tùy chỉnh dynamic length
  const reformatDecimal =
    showDecimal?.dynamicLength !== false
      ? // Xóa các số 0 dư ở sau
        toFixedDecimal.replace(/0+$/, '')
      : toFixedDecimal

  const decimalRender =
    reformatDecimal && reformatDecimal.length >= 1 ? `.${reformatDecimal}` : ''

  return `${numberWithCommas(integer)}${decimalRender}`
}

export default formatNumberWithDecimal
